import {
  type UseQueryOptions,
  type UseQueryReturnType,
  useQuery,
} from '@tanstack/vue-query'
import type { MaybeRef } from '@vueuse/core'
import { getOwnershipInformation } from '~~/src/api/elementals'
import type { GetReturn } from '~~/src/types/utils'

export const useOwnershipDataQuery = (
  args: {
    id?: MaybeRef<string | null | undefined>
    isAdmin?: MaybeRef<boolean | undefined>
  },
  options?: Omit<
    UseQueryOptions<
      GetReturn<typeof getOwnershipInformation>,
      Error
    >,
    'queryKey' | 'queryFn' | 'placeholderData' | 'keepPreviousData'
  >,
): UseQueryReturnType<GetReturn<typeof getOwnershipInformation>, Error> => {
  return useQuery({
    queryKey: ['elemental-ownership-data', args.id, args.isAdmin] as const,
    queryFn: async ({ queryKey }) => {
      if (!queryKey[1])
        throw new Error('Missing id')
      const [_, id, isAdmin] = queryKey
      return await getOwnershipInformation(id, isAdmin)
    },
    ...options,
  })
}
